export const globalSearchTestIds = {
  trigger: 'global-search-trigger',
  dialog: 'global-search-dialog',
  input: 'global-search-input',
  item: (key: string) => `global-search-item-${key}` as const,
  itemCategory: (key: string) => `global-search-item-${key}-category` as const,
} as const;
